/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { RRuleOption } from '../rrule/rrule.type';
import * as dayjs from 'dayjs';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { UntypedFormGroup } from '@angular/forms';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import moment from 'moment';


@Component({
  selector: 'app-recurrence-schedule',
  templateUrl: './recurrence-schedule.component.html',
  styleUrls: ['./recurrence-schedule.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecurrenceScheduleComponent implements OnInit {

  @Input()formGroup: UntypedFormGroup;
  @Input() isDisabled?: boolean = false;
  @Output() eventChange: EventEmitter<any> = new EventEmitter();

  startTimeStepper: number = 15;
  endTimeStepper: number = 15;

  duration: UntypedFormGroup;
  dateFormat: string = 'DD/MM/YYYY';
  timeFormat: string = 'HH:mm:ss';
  enableMeridian: boolean = false;
  timePickerModel: any = {};
  timePickerData: any = {};
  durationObj: any = {
    'DAYS': 'Days',
    'WEEKS': 'Weeks',
    'MONTHS': 'Months',
    'YEARS': 'Years'
  };

  rruleOptions: RRuleOption = {
    frequency: 'DAILY',
    repeat: 1,
    rrule: ''
  };

  updatedRruleOptions: RRuleOption = {
    rrule: ''
  };

  rrule: string;
  showRrule: boolean = false;
  timeInit: any = {
    start: false,
    end: false
  };
  timezone: string;
  constructor(
    public utilityService: UtilityService,
    private _timeFormatPipe: TimeFormatPipe
  ) { }

  getDurationArray(): any {
    return Object.keys(this.durationObj);
  }

  selectDuration(key: string): void {
    if(this.duration.get('type').value !== key){
      this.updatedRruleOptions.rrule = '';
    }
    this.duration.get('type').setValue(key);
  }

  setTimeFormControl(controlName: string, event): void {
    this.timePickerModel[controlName] = event;
    if(this.formGroup.controls[controlName].value || this.formGroup.controls[controlName].value === null ){
      this.formGroup.controls[controlName].setValue(moment(this.timePickerModel[controlName]).format(this.timeFormat));
      this.timePickerData[controlName] = moment(this.timePickerModel[controlName]).format(this.timeFormat);
    }else{
      this.formGroup.controls[controlName].setValue(null);
    }
    if(!this.timeInit['start']){
      this.timeInit['start'] = true;
    }
    else if(this.timeInit['start'] && !this.timeInit['end']){
      this.timeInit['end'] = true;
    }
    else if(this.timeInit['start'] && this.timeInit['end']){
        this.updatedRruleOptions['rrule'] = '';
    }
    this.checkFormChange();
  }

  startTimeChange(): void {
    this.startTimeStepper = this.utilityService.getNextQuarterStepperMin(moment(this.timePickerModel['startTime']).clone());
  }
  endTimeChange(): void {
    this.endTimeStepper = this.utilityService.getNextQuarterStepperMin(moment(this.timePickerModel['endTime']).clone());
  }

  setFormGroupValue(): void {
    this.timezone = this.utilityService.preferredTimeZone;
    if(this.utilityService.isTimeZoneEnabled && this.formGroup.get('job_timezone')?.value){
      this.timezone = this.formGroup.get('job_timezone').value;
    }
    moment.tz.setDefault(this.timezone);
    dayjs.tz.setDefault(this.timezone);
    const currentQuarterTime= this.utilityService.getNextQuarterHour(moment(),true);
    if(!this.formGroup.get('startFrom').value){
      this.formGroup.get('startFrom').setValue(currentQuarterTime);
    }
    let startTime = currentQuarterTime
    let endTime = currentQuarterTime
    if(this.formGroup.get('startTime').value){
      startTime = moment(this.formGroup.get('startTime').value);
    }
    if(this.formGroup.get('endTime').value){
      endTime = moment(this.formGroup.get('endTime').value);
    }
    this.timePickerModel = {
      'startTime': startTime,
      'endTime': endTime,
    }
    this.timePickerData = {
      'startTime': startTime.format(this.utilityService.timeFormat),
      'endTime': endTime.format(this.utilityService.timeFormat)
    }
    this.formGroup.patchValue(this.timePickerData)
    // this.checkValueChange();
    setTimeout(() => {
    // set Time out added to make sure form control value set before fetches properly
      this.checkFormChange();
    }, 0);
  }

  checkValueChange(): void {
    this.formGroup.valueChanges.subscribe(
      (res: any) => {
        if(res?.duration?.value && dayjs(this.formGroup.get('endTime')?.value, this.timeFormat, true).isValid() && dayjs(this.formGroup.get('startTime')?.value, this.timeFormat, true).isValid()){
          this.updatedRruleOptions['rrule'] = '';
          const startDate = dayjs(this.formGroup.get('startFrom').value).format('YYYY-MM-DD');
          this.updatedRruleOptions['date'] = dayjs(startDate +' '+ this.formGroup.get('startTime').value, 'YYYY-MM-DD '+this.timeFormat).format('YYYY-MM-DD HH:mm:ss');
          const formattedDate = dayjs(startDate +' '+ this.formGroup.get('endTime').value, 'YYYY-MM-DD '+this.timeFormat).format('YYYY-MM-DD HH:mm:ss');
          if(res?.duration?.type === 'MONTHS'){
            this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(res?.duration?.value, 'months').format('YYYY-MM-DD HH:mm:ss');
          }else if(res?.duration?.type === 'WEEKS'){
            this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(res?.duration?.value, 'weeks').format('YYYY-MM-DD HH:mm:ss');
          }else if(res?.duration?.type === 'DAYS'){
            this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(res?.duration?.value, 'days').format('YYYY-MM-DD HH:mm:ss');
          }else if(res?.duration?.type === 'YEARS'){
            this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(res?.duration?.value, 'years').format('YYYY-MM-DD HH:mm:ss');
          }
          this.rruleOptions = {...this.rruleOptions, ...this.updatedRruleOptions};
          this.showRrule = true;
        }
      }
    );
  }

  setFormChange(): void {
    this.updatedRruleOptions['rrule'] = '';
    this.checkFormChange();
  }

  checkFormChange(): void {
    let isEndTimeValid  = dayjs(this.formGroup.get('endTime')?.value, this.timeFormat, true).isValid();
    let isStartTimeValid = dayjs(this.formGroup.get('startTime')?.value, this.timeFormat, true).isValid()
    if(this.duration?.value &&  isEndTimeValid && isStartTimeValid ){
      this.updatedRruleOptions['rrule'] = '';
      const startDate = dayjs(this.formGroup.get('startFrom').value).format('YYYY-MM-DD');
      this.updatedRruleOptions['date'] = dayjs(startDate +' '+ this.formGroup.get('startTime').value, 'YYYY-MM-DD '+this.timeFormat).format('YYYY-MM-DD HH:mm:ss');
      const formattedDate = dayjs(startDate +' '+ this.formGroup.get('endTime').value, 'YYYY-MM-DD '+this.timeFormat).format('YYYY-MM-DD HH:mm:ss');
      if(this.duration?.value?.type === 'MONTHS'){
        this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(this.duration?.value?.value, 'months').subtract(1,'days').format('YYYY-MM-DD HH:mm:ss');
      }else if(this.duration?.value?.type === 'WEEKS'){
        this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(this.duration?.value?.value, 'weeks').subtract(1,'days').format('YYYY-MM-DD HH:mm:ss');
      }else if(this.duration?.value?.type === 'DAYS'){
        this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(this.duration?.value?.value, 'days').subtract(1,'days').format('YYYY-MM-DD HH:mm:ss');
      }else if(this.duration?.value?.type === 'YEARS'){
        this.updatedRruleOptions['toDate'] = dayjs(formattedDate, 'YYYY-MM-DD HH:mm:ss').add(this.duration?.value?.value, 'years').subtract(1,'days').format('YYYY-MM-DD HH:mm:ss');
      }
      this.rruleOptions = {...this.rruleOptions, ...this.updatedRruleOptions};
      this.showRrule = true;
    }
  }

  getRrule(event: RRuleOption): void {
    if(event?.date){
      this.eventChange.emit(event);
    }else{
      this.eventChange.emit(null);

    }
    this.updatedRruleOptions = {...event};

  }

  formSubmit(): void {
    this.formGroup.markAllAsTouched();
  }

  ngOnInit(): void {
    this.dateFormat = this.utilityService.dateFormat;
    this.timeFormat = this.utilityService.timeFormat;
    this.enableMeridian = this.utilityService.showMeridian;
    this.duration = this.formGroup.get('duration') as UntypedFormGroup;
    if(this.formGroup.get('rrule')?.value){
      setTimeout(()=>{
        this.rruleOptions = {
          rrule: this.formGroup.get('rrule')?.value
        };
        this.showRrule = true;
      });
    }
    this.setFormGroupValue();
  }

}
